export var EActorKind;
(function (EActorKind) {
    EActorKind[EActorKind["User"] = 1] = "User";
    EActorKind[EActorKind["Bot"] = 2] = "Bot";
})(EActorKind || (EActorKind = {}));
//# sourceMappingURL=actor.enum.js.map